import React from 'react';
import TextToDownload from '../textToDownload';
import AppleStoreIcon from 'images/apple-store-icon.png';
import GooglePlayIcon from 'images/google-play-icon.png';
import MadeInLA from 'images/made-in-la.svg';

function Footer() {
  return (
    <footer id="footer">
      <div className="row footer">
        <div className="made-in-la">
          <img src={MadeInLA} />
        </div>
        <div className="col-md-3 col-sm-6 col-xs-12 footer-column footer-social">
          <h4>Follow Us, We{"'"}ll Make You Famous</h4>
          <div className="row footer-social-icons">
            <div className="col-xs">
              <a href="https://www.facebook.com/SauceyApp">
                <i className="icon-facebook" />
              </a>
            </div>
            <div className="col-xs">
              <a href="https://twitter.com/sauceyapp">
                <i className="icon-twitter" />
              </a>
            </div>
            <div className="col-xs">
              <a href="https://www.instagram.com/sauceyapp">
                <i className="icon-instagram" />
              </a>
            </div>
            <div className="col-xs">
              <a href="https://plus.google.com/+Sauceyapp">
                <i className="icon-google-plus" />
              </a>
            </div>
          </div>
        </div>
        <div className="col-sm-2 col-xs-4 footer-column footer-company">
          <h4>Cities</h4>
          <div className="footer-links">
            <a href="/cities/alcohol-delivery-los-angeles/">Los Angeles</a>
            <a href="/cities/alcohol-delivery-san-francisco/">San Francisco</a>
            <a href="/cities/alcohol-delivery-san-diego/">San Diego</a>
            <a href="/cities/alcohol-delivery-chicago/">Chicago</a>
            <a href="/cities/alcohol-delivery-sacramento/">Sacramento</a>
            <a href="/cities/alcohol-delivery-oakland/">Oakland</a>
          </div>
        </div>
        <div className="col-sm-2 col-xs-4 footer-column footer-contact">
          <h4>Company</h4>
          <div className="footer-links">
            <a href="http://help.sauceyapp.com">Contact Us</a>
            {/* <a href="http://help.sauceyapp.com/customer/en/portal/topics/933398-about-saucey/articles">FAQ</a> */}
            <a href="/terms-of-service">Terms of Service</a>
            <a href="/privacy-policy">Privacy Policy</a>
            <a href="/returns-refunds">Returns & Refunds</a>
            {/* <a href="#">About Us</a> */}
            <a href="/careers">Careers</a>
            {/* <a href="#">Media &amp; Press</a> */}
            <a href="/blog">Blog</a>
            <a href="https://sauceyapparel.com/">Saucey Apparel</a>
          </div>
        </div>
        <div className="col-sm-2 col-xs-4 footer-column footer-partnerships">
          <h4>Partnerships</h4>
          <div className="footer-links">
            <a href="/business">Corporate Accounts</a>
            <a href="/retailers">Retail Partners</a>
            <a href="/apply">Become A Courier</a>
            {/* <a href="#">Brand Partners</a> */}
          </div>
        </div>
        <div className="col-md-3 col-xs-12 footer-column footer-apps">
          <h4>Get The App</h4>
          <div className="app-download">
            <TextToDownload section="Footer" />
            <div className="download-btn">
              <div id="app-imgs">
                <a href="https://app.adjust.com/o079l9_f06dhc">
                  <img src={AppleStoreIcon} />
                </a>
                <a href="https://app.adjust.com/f06dhc_o079l9">
                  <img src={GooglePlayIcon} />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;



// WEBPACK FOOTER //
// ./shared/components/footer/index.js